<template>
  <dialog-wrap-upgrade
    ref="batchImport"
    :configOptions="configOptions"
    @open="$emit('open')"
    @close="$emit('close')"
  >
    <div class="importPopup">
      <slot />
      <div class="button">
        <el-upload
          v-show="false"
          class="upload"
          action=""
          :http-request="uploadRequest"
          :autoUpload="true"
          :file-list="fileList"
          :show-file-list="false"
        >
          <el-button
            ref="telUpload"
            :loading="loading.upload"
            type="primary"
            size="small"
            >导入数据</el-button
          >
        </el-upload>
        <el-button
          @click="handleUpload"
          :loading="loading.upload"
          type="primary"
          size="small"
          >导入数据</el-button
        >
        <el-button type="primary" size="small" v-if="templateUrl">
          <a :href="getTemplateUrl">下载模板</a>
        </el-button>
      </div>
    </div>
  </dialog-wrap-upgrade>
</template>

<script>
import axios from 'axios'

import { getHead } from '@/utils'

export default {
  model: {
    prop: 'importPopupShow',
    event: 'change',
  },
  props: {
    // eslint-disable-next-line vue/no-unused-properties
    importPopupShow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '导入',
    },
    templateUrl: {
      type: String,
      default: '',
    },
    upload: {
      type: Function,
      default: () => {},
    },
    group: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      fileList: [],
      loading: {
        upload: false,
      },
      // 弹框配置信息
      configOptions: {
        isDefaultMode: true,
        attrs: {
          title: this.title,
          width: '1000px',
        },
      },
    }
  },
  methods: {
    // 展示弹框
    // eslint-disable-next-line vue/no-unused-properties
    showDialog() {
      this.$refs.batchImport.showDialog()
    },
    // 关闭弹框
    // eslint-disable-next-line vue/no-unused-properties
    closeDialog() {
      this.$refs.batchImport.close()
      // 关闭弹窗时清空文件列表、loading
      this.loading.upload = false
      this.fileList = []
    },
    // 点击上传按钮
    handleUpload() {
      // 父组件的校验逻辑
      if (this.$listeners.validate) {
        this.$emit('validate', () => {
          this.$refs.telUpload.$el.click()
        })
        return
      }

      this.$refs.telUpload.$el.click()
    },
    /* 自定义上传 */
    uploadRequest({ file }) {
      const size = file.size / 1024 / 1024
      if (size > 100) {
        this.$message.error('上传文件超过100M')
        return
      }
      this.loading.upload = true
      const formData = new FormData()
      formData.append('file', file)
      if (this.group) formData.append('group', this.group)
      if (this.code) formData.append('code', this.code)

      axios({
        url: '/admin/v1/vehicle/fs/standard/upload',
        method: 'POST',
        data: formData,
        headers: {
          ...this.headers,
          ...getHead(this.$store),
        },
        onUploadProgress: ({ loaded, total }) => {
          this.isProgress = true
          this.disabled = true
          this.uploadPercent = parseInt(loaded / total)
        },
      })
        .then(({ data: { code, data, msg } }) => {
          if (code === 1) {
            this.upload(data, file)
          } else {
            this.$message.error(msg)
            this.fileList = []
          }
          this.loading.upload = false
        })
        .catch(() => {
          this.loading.upload = false
          this.fileList = []
        })
    },
  },
  computed: {
    getTemplateUrl() {
      return this.templateUrl
    },
  },
}
</script>

<style lang="scss" scoped>
.importPopup {
  .button {
    display: flex;

    .upload {
      margin-right: 10px;
    }

    a {
      color: white;
    }
  }
}
</style>
